import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabsSharedComponent } from './tabs.component';
import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';

@NgModule({
    declarations: [
        TabsSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule
    ],
    exports: [
        TabsSharedComponent
    ]
})

export class TabsSharedModule {}
